import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import AccordianContentLeft from "./AccordianContentLeft";
import AccordianContentRight from "./AccordianContentRight";

const FaqContent = () => {
  const { language } = useLocation();

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="align-items-center">
            <Col lg={12}>
              <Row>
                <Col lg={6}>
                  <div
                    className="accordion accordion-flush faq-box"
                    id="buying"
                  >
                    <AccordianContentLeft />
                  </div>
                </Col>
                <Col lg={6}>
                  <div
                    className="accordion accordion-flush faq-box"
                    id="generalTwo"
                  >
                    <AccordianContentRight />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={12}>
              <div className="text-center mt-5">
                <Link to="/contact" className="btn btn-primary btn-hover mt-2">
                  <i className="uil uil-phone"></i>{" "}
                  {language === "pt" ? "Contate-nos" : "Contact us"}
                </Link>
                <a
                  href="mailto:info@epmanagementconsult.com"
                  className="btn btn-warning btn-hover mt-2 ms-md-2"
                >
                  <i className="uil uil-envelope"></i>{" "}
                  {language === "pt" ? "Enviar E-mail" : "Send E-mail"}
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default FaqContent;
